<div class="pb-4 p-md-0">
  <div class="row g-4">
    <div
      *ngIf="
        !order_type_settings?.restrict_transfer_to_another_carrier &&
        transfer_of_liability_attributes?.keep_existing_carrier?.name
      "
      class="col col-12"
    >
      <label class="form-label"> {{ 'change_current_carrier' | translate }} </label><br />
      <span>{{ transfer_of_liability_attributes?.keep_existing_carrier?.name }}</span>
    </div>

    <div class="col col-12">
      <label class="form-label"> {{ 'personal_email' | translate }} </label>
      <br />
      <span>{{ transfer_of_liability_attributes?.created_for_personal_email }}</span>
    </div>

    <div *ngIf="transfer_of_liability_attributes?.transfer_notes" class="col col-12">
      <label class="form-label"> {{ 'transfer_notes' | translate }} </label>
      <br />
      <div class="row">
        <div class="col">
          <div class="d-flex flex-column">
            <span>{{ transfer_of_liability_attributes?.transfer_notes }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
